import { usePatchLandelijkeFaciliteiten, VestigingStatus } from "@/entities/vestiging";
import { Button } from "@/shared/components";

type RespondToAanvraagActionProps = {
    dossierId: string;
    status: VestigingStatus | undefined;
    toelichting: string | undefined;
};

export function RespondToAanvraagAction({ dossierId, status, toelichting }: RespondToAanvraagActionProps) {
    const { mutate: patchLandelijkeFaciliteiten } = usePatchLandelijkeFaciliteiten();

    const aanvraagHandler = () => {
        let newStatus: VestigingStatus;
        if (status == "Besteld") {
            newStatus = "Actief";
        } else if (status === "StopAangevraagd") {
            newStatus = "Gestopt";
        } else {
            // Other statuses "Actief" and "" should never happen
            newStatus = "GaatNietLeveren";
        }
        patchLandelijkeFaciliteiten({ dossierId, status: newStatus, toelichting });
    };

    if (status == null) {
        // No aanvraag yet, nothing for klantenservice to do
        return null;
    }

    switch (status) {
        case "Actief":
        case "Gestopt":
        case "GaatNietLeveren":
            return null;
        case "Besteld":
            return (
                <div className="flex w-full flex-col items-end gap-4">
                    <Button
                        className="w-min text-nowrap"
                        variant="secondary"
                        data-testid="confirm-landelijke-faciliteiten-request"
                        onClick={aanvraagHandler}
                    >
                        Landelijke faciliteiten aangezet in AXI
                    </Button>
                </div>
            );
        case "StopAangevraagd":
            return (
                <div className="flex w-full flex-col items-end gap-4">
                    <Button
                        className="w-min text-nowrap"
                        destructive
                        variant="secondary"
                        data-testid="confirm-landelijke-faciliteiten-request"
                        onClick={aanvraagHandler}
                    >
                        Landelijke faciliteiten uitgeschakeld in AXI
                    </Button>
                </div>
            );
    }
}
